import React from "react";
import { useNavigate } from "react-router";
import { StyckeCompact } from "./ContentStyles";
import Rules from "./Rules";
import { Branding } from "../services/misc";
import "./PricePage.scss";
import { BsLightning } from "react-icons/bs";
import { FaStore } from "react-icons/fa";
import { IoWifi } from "react-icons/io5";
import { IoCartOutline } from "react-icons/io5";
import { GiReceiveMoney } from "react-icons/gi";
import { FaMobileAlt } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const PricingModule = () => {

      const plans = [
        {
            key: "NS1",
            title: "Kylskåp 250L",
            price: "1295:-",
            period: "/månad",
            details: [
                { label: "Bindningstid", value: "36 månader" },
                { label: "Startkostnad", value: "0:-" },
                { label: "Månadskostnad", value: "1295:-" },
                { label: "Antal varor", value: "25" },
                { label: "Antal produktgrupper", value: "5" },
                { label: "Uppkoppling", value: "WiFi" },
                { label: "Transaktionskostnad", value: "0.20:-/köp" },
                { label: "Applikationsexempel", value: "Tex: Lunch, dryck, snacks mm", isExample: true },
            ],
            featured: false,
        },
        {
            key: "NS2",
            title: "Butik micro",
            price: "495:-",
            period: "/månad",
            details: [
                { label: "Bindningstid", value: "24 månader" },
                { label: "Startkostnad", value: "0:-" },
                { label: "Månadskostnad", value: "495:-" },
                { label: "Antal varor", value: "5" },
                { label: "Antal produktgrupper", value: "1" },
                { label: "Uppkoppling", value: "WiFi" },
                { label: "Transaktionskostnad", value: "0.20:-/köp" },
                { label: "Applikationsexempel", value: "Tex: Honung, äggförsäljning", isExample: true },
            ],
            featured: false,
        },
        {
            key: "NS3",
            title: "Butik standard",
            price: "1495:-",
            period: "/månad",
            details: [
                { label: "Bindningstid", value: "24 månader" },
                { label: "Startkostnad", value: "0:-" },
                { label: "Månadskostnad", value: "1495:-" },
                { label: "Antal varor", value: "50" },
                { label: "Antal produktgrupper", value: "5" },
                { label: "Uppkoppling", value: "WiFi" },
                { label: "Transaktionskostnad", value: "0.20:-/köp" },
                { label: "Applikationsexempel", value: "Tex: Gårdsbutik, 9-Hålet", isExample: true },
            ],
            featured: true,
        },
        {
            key: "NS4",
            title: "Butik large",
            price: "2495:-",
            period: "/månad",
            details: [
                { label: "Bindningstid", value: "24 månader" },
                { label: "Startkostnad", value: "0:-" },
                { label: "Månadskostnad", value: "2495:-" },
                { label: "Antal varor", value: "200" },
                { label: "Antal produktgrupper", value: "20" },
                { label: "Uppkoppling", value: "WiFi" },
                { label: "Transaktionskostnad", value: "0.20:-/köp" },
                { label: "Applikationsexempel", value: "Tex: Gårdsbutik, Kiosk, Närbutik", isExample: true },
            ],
            featured: false,
        },
    ];

  return (
<>
                {/* CARDS */}
                <section className="pricing-cards" aria-labelledby="pricing-packages-title">
                    <p className="pricing-cards__intro">
                        Här kan du jämföra våra olika abonnemang för obemannad butik och välja den lösning som passar din verksamhet bäst.
                    </p>
                    <div className="pricing-cards__grid">
                        {plans.map((p) => (
                            <article
                                key={p.key}
                                className={`pricing-card ${p.featured ? "pricing-card--featured" : ""}`}
                                aria-labelledby={`plan-title-${p.key}`}
                            >
                                {p.featured && (
                                    <div className="pricing-card__badge">Mest populär</div>
                                )}

                                <h3 id={`plan-title-${p.key}`} className="pricing-card__title">{p.title}</h3>

                                <div className="pricing-card__priceRow">
                                    <div className="pricing-card__price">{p.price}</div>
                                    <div className="pricing-card__period">{p.period}</div>
                                </div>

                                <div className="pricing-card__details" role="list">
                                    {p.details.map((d, idx) => (
                                        <div
                                            key={idx}
                                            className={`pricing-row ${d.isExample ? "pricing-row--example" : ""}`}
                                            role="listitem"
                                        >
                                            <div className="pricing-row__label">{d.label}</div>
                                            <div className="pricing-row__value">{d.value}</div>
                                        </div>
                                    ))}
                                </div>

{/*                                 <button
                                    className="pricing-card__cta"
                                    style={
                                        p.featured
                                            ? { backgroundColor: "#fff", color: "#ff8800" }
                                            : { backgroundColor: "#ff8800", color: "#fff" }
                                    }
                                    onClick={() => handleSubmitProd(p.key)}
                                    type="button"
                                    aria-label={`Välj paketet ${p.title}`}
                                >
                                    Starta med detta paket <span className="pricing-card__arrow">→</span>
                                </button> */}
                            </article>
                        ))}
                    </div>

                    <div className="pricing-note">
                        <StyckeCompact>
                            För att en fysisk butik ska fungera behövs ett elektriskt lås. En lokal låssmed kan hjälpa dig med installationen.
                            <br />
                            Fakturering sker i förväg, tre månader i taget. Uppsägning av tjänsten ska ske innan en ny tremånadersperiod påbörjas.
                            <Rules />
                        </StyckeCompact>
                    </div>
{/*                     <p className="pricing-more">
                        Är du osäker på vilket paket som passar? Läs mer om <Link to="/starta">hur du startar din butik</Link> eller <Link to="/contact">kontakta oss</Link>.
                    </p> */}
                </section>

</>    

  );
};

export default PricingModule;